import React from 'react';
import { Icon } from '../../interfaces/Icon';

export const WarningIcon: Icon = props => {
  return (
    <svg
      data-testid="warning-icon"
      width="24px"
      viewBox="0 0 150 150"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M148.199 131.109L86.1226 6.88133C85.0884 4.81233 83.498 3.07192 81.5298 1.85566C79.5615 0.639401 77.2932 -0.00457764 74.9792 -0.00457764C72.6651 -0.00457764 70.3968 0.639401 68.4285 1.85566C66.4603 3.07192 64.87 4.81233 63.8358 6.88133L1.31845 132.028C0.371042 133.907 -0.0789644 135.998 0.0113463 138.1C0.101657 140.202 0.729277 142.247 1.83435 144.038C2.95127 145.856 4.51495 147.358 6.37676 148.402C8.23857 149.445 10.3365 149.995 12.4712 150H137.562C140.859 149.993 144.018 148.68 146.349 146.35C148.68 144.021 149.993 140.864 150 137.569C149.994 135.293 149.372 133.06 148.199 131.109V131.109ZM75.0355 137.494C72.5625 137.494 70.1451 136.761 68.0889 135.388C66.0327 134.014 64.4301 132.063 63.4837 129.779C62.5374 127.496 62.2898 124.983 62.7722 122.559C63.2547 120.135 64.4455 117.908 66.1942 116.16C67.9428 114.413 70.1707 113.223 72.5962 112.74C75.0216 112.258 77.5356 112.505 79.8203 113.451C82.1051 114.397 84.0578 115.999 85.4317 118.054C86.8056 120.109 87.5389 122.525 87.5389 124.997C87.2738 128.227 85.8691 131.257 83.5755 133.548C81.2819 135.839 78.2485 137.241 75.0167 137.503L75.0355 137.494ZM87.5389 99.9939H62.5414L61.6033 37.4908H88.3737L87.5389 99.9939Z" />
    </svg>
  );
};

export default WarningIcon;
